"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _bootstrapInput = _interopRequireDefault(require("./bootstrapInput"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// NOTE FOR DEVELOPER: Add instructions for props what are the input types.

var SelectMenu = function SelectMenu(field, formValues, handleInputChange, data, classes) {
  var propOptions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var disabled = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var id = field.id,
    custodianOptions = field.options,
    optionsAPIField = field.optionsAPIField,
    multiple = field.multiple,
    required = field.required,
    label = field.label;
  function getOptions() {
    return propOptions || (optionsAPIField && data && data[optionsAPIField] ? data[optionsAPIField] : custodianOptions);
  }
  var selectOptions = getOptions();
  var getShortLabel = function getShortLabel(orignalLabel) {
    return orignalLabel.split(',')[0];
  };
  var getSelectView = function getSelectView(selectedKey) {
    var sortedOptions = Object.keys(selectOptions).reduce(function (previouslySortedOptions, key) {
      var newSortedOptions = previouslySortedOptions;
      if (selectedKey.includes(selectOptions[key].id)) newSortedOptions.push(selectOptions[key]);
      return newSortedOptions;
    }, []);
    var firstOption = getShortLabel(sortedOptions[0].name);
    if (selectedKey.length <= 1) return firstOption;
    return /*#__PURE__*/_react.default.createElement("div", null, firstOption, ' and ', selectedKey.length - 1, ' others');
  };
  var getLabel = function getLabel(selectedKeys) {
    if (selectedKeys.length === 0) return label;
    if (multiple) return getSelectView(selectedKeys);
    return getSelectView([selectedKeys]);
  };
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_FormControl.default, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.formLabel
  }, label, required ? /*#__PURE__*/_react.default.createElement("span", {
    className: classes.required
  }, "*") : null), /*#__PURE__*/_react.default.createElement(_Select.default, {
    id: "demo-customized-select-native",
    multiple: multiple,
    disabled: disabled,
    name: id,
    displayEmpty: true
    // eslint-disable-next-line react/destructuring-assignment
    ,

    value: formValues[id],
    required: required,
    onChange: handleInputChange,
    input: /*#__PURE__*/_react.default.createElement(_bootstrapInput.default, null),
    className: classes.inputSelect,
    MenuProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      getContentAnchorEl: null
    }
    // error={!checkIsValid(field, formValues)}
    ,

    renderValue: function renderValue(selectedKeys) {
      return getLabel(selectedKeys);
    }
  }, selectOptions.map(function (_ref) {
    var key = _ref.id,
      name = _ref.name;
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      dense: true,
      key: key,
      value: key,
      className: classes.selectMenuItem
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default
    // eslint-disable-next-line react/destructuring-assignment
    , {
      checked: formValues[id].indexOf(key) > -1
    }), name);
  }))));
};
var _default = SelectMenu;
exports.default = _default;